module.exports = __webpack_public_path__ + "static/media/spectrophotometer-info-3.be5355a1.svg";